
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tenants",
      function () {
        return require("private-next-pages/tenants.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tenants"])
      });
    }
  